import { StyleSheet } from 'react-native';

import { C } from '../../../../common';
import { LAYOUT, THEME } from '../../../../reactor/common';

const { CONTENT_MAX_WIDTH, PAGE_OFFSET } = C;
const { UNIT, OFFSET } = THEME;
const { VIEWPORT: { PORTRAIT } } = LAYOUT;

export default StyleSheet.create({
  container: {
    alignSelf: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    maxWidth: CONTENT_MAX_WIDTH,
    width: '100%',
    paddingHorizontal: 0,
  },

  slider: {
    marginLeft: PAGE_OFFSET,
  },

  rights: {
    marginTop: PORTRAIT ? UNIT : 0,
    paddingHorizontal: OFFSET,
    textAlign: 'right',
    width: '100%',
  },
});
